import { CellphoneOffIcon } from './CellphoneOffIcon';

/**
 * author: Google
 * id 2AD1736A-2142-4E3D-BA70-9CF8584C366D
 * name cellphone-off
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cellphone-off.svg
 * tags
 * - Cellphone / Phone 
 * - Device / Tech 
 */
export const SmartphoneOffIcon = CellphoneOffIcon;
export default SmartphoneOffIcon